import { Div, Icon, Label } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { images } from "../../../layout/assets";
import { PlayerWinner } from "../../../components/shared";
import { PlayerTotals } from "@grassrootly/api";

interface PlayerStatsProps {
  totals: PlayerTotals | null;
}

export default function PlayerStats({ totals }: PlayerStatsProps) {
  return (
    <Div classNames={["w100", "maxW-{420}", "ml-{auto}", "mr-{auto}"]}>
      {/* Icon rows */}
      <Div classNames={["flexRow", "justifyContentSpaceAround", "mt-{8}"]}>
        <StatIcon icon="sports_soccer" value={String(totals?.total_goals_scored || 0)} />
        <StatImage source={images.assist} value={String(totals?.total_assists_made || 0)} />
      </Div>
      {/* Results visuals (W/D/L) with same position and aligned like icons */}
      <Div classNames={["mt-{16}", "alignItemsCenter"]}>
        <Div classNames={["flexRow", "justifyContentSpaceAround", "w100", "maxW-{360}"]}>
          <OutcomeWithCount outcome="W" count={totals?.total_wins || 0} />
          <OutcomeWithCount outcome="D" count={totals?.total_draws || 0} />
          <OutcomeWithCount outcome="L" count={totals?.total_lost || 0} />
        </Div>
      </Div>
    </Div>
  );
}

function StatIcon({ icon, value }: { icon: import("@grassrootly/rn-core").IconName; value: string }) {
  return (
    <Div classNames={["alignItemsCenter", "ph-{8}"]}>
      <Icon name={icon} size={36} />
      <Label classNames={["mt-{6}"]}>{value}</Label>
    </Div>
  );
}

function StatImage({ source, value }: { source: any; value: string }) {
  return (
    <Div classNames={["alignItemsCenter", "ph-{8}"]}>
      <Image source={source} style={{ height: 28, width: 44 }} resizeMode="contain" />
      <Label classNames={["mt-{6}"]}>{value}</Label>
    </Div>
  );
}

function OutcomeWithCount({ outcome, count }: { outcome: "W" | "D" | "L"; count: number }) {
  return (
    <Div classNames={["alignItemsCenter", "ph-{8}"]}>
      <PlayerWinner outcome={outcome} playerAttended={true} size={16} classNames={["h-{28}", "w-{28}"]} />
      <Label classNames={["mt-{6}"]}>{count}</Label>
    </Div>
  );
}
